import { increment, onValue, ref } from "firebase/database";
import { YEAR, MAX_SETS_PER_DAY } from "./config";

// Per-date booked-set counters live under this node, keyed by date
// ("2026-09-04": 12). A fresh node per year means counters reset with
// the season.
export const BOOKED_SETS_PATH = `bookedSets${YEAR}`;

// Multi-path update that shifts the per-date booked counts by the
// cart's sets. sign +1 books the sets, -1 releases them.
export const bookedSetsDelta = (cart, sign) => {
  const updates = {};
  (cart?.dates || []).forEach((date, i) => {
    const count = cart?.sets?.[i] || 0;
    if (count > 0) {
      updates[`${BOOKED_SETS_PATH}/${date}`] = increment(sign * count);
    }
  });
  return updates;
};

export const remainingSets = (bookedByDate, date) => {
  const booked = Math.max(0, (bookedByDate && bookedByDate[date]) || 0);
  return Math.max(0, MAX_SETS_PER_DAY - booked);
};

// Watch the per-date booked counters. A listener that gets
// permission_denied is cancelled permanently by the SDK (it will not
// recover even if security rules are fixed afterwards), so on
// cancellation this resubscribes with exponential backoff instead of
// staying dark until the next page load. The callback receives the
// counts object, or null while the counters are unavailable. Returns a
// cleanup function.
export const watchBookedSets = (db, callback) => {
  let stopped = false;
  let unsubscribe = null;
  let timer = null;
  let attempt = 0;

  const subscribe = () => {
    if (stopped) return;
    try {
      unsubscribe = onValue(
        ref(db, BOOKED_SETS_PATH),
        (snapshot) => {
          attempt = 0;
          callback(snapshot.val() || {});
        },
        () => {
          unsubscribe = null;
          callback(null);
          const delay = Math.min(60000, 5000 * 2 ** attempt);
          attempt += 1;
          timer = setTimeout(subscribe, delay);
        },
      );
    } catch (error) {
      callback(null);
    }
  };

  subscribe();
  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
    if (unsubscribe) unsubscribe();
  };
};
